"use strict";

(function (global) {

  /**
* Диалог для работы с формами запроса параметров отчетов.
* @class WebAccess.components.dialogs.ReportParamsDialog
* @extends WebAccess.components.dialogs.FormDialog
* @mixes WebAccess.mixins.formMixin
* @property {Deferred} Init меняет сосотояние при инициализации элементов управления формы
* @property {Object} model переданная в конструктор модель  
* @property {String} serviceURL адрес веб-сервиса обслуживающего диалог
* @since 5.2.0.1931  
*/
  var ReportParamsDialog = global.FormDialog.extend({
    className: 'ReportParamsDialog',
    width: "600",
    title: L('REPORT_ASKABLE_PARAMS'),

    init: function (settings, model) {
      if (!model) WA.raise(L("ERR_NOT_ALL_REQUIRED_ARGUMENTS_HAVE_BEEN_SUPLIED"));

      var me = this;
      var formData = JSON.parse(model.FormData);
      me.model = model;
      me.requisitesModels = formData.req;

      me._fillHiddenParamsCallback = formData._fillHiddenParamsCallback;

      me.isShowOkButton = true;
      me.isShowCancelButton = true;

      me._pendingOperations = {};
      me._preInit();
      me._containerInit = $.Deferred();
      me._detailsGridInit = $.Deferred();
      me._postInit();

      me._setKeyBindings();

      return this;
    },

    /**
     * Создание html разметки и контейнеров
     *
     * @method WebAccess.components.dialogs.ReportParamsDialog#_beforeShow
     * @private
     * @return {Deferred<void>}
     * @see https://api.jquery.com/category/deferred-object/
     */
    _beforeShow: function () {
      var def = $.Deferred();
      var me = this;

      // WindowModal возвращает разметку в притык, без отступов, поэтому добавляемых их вручную.
      me.model.FormHtml = format('<div class="report_params_dialog_padding">{0}</div>', me.model.FormHtml);

      me._super().done(function () {
        me.isShowOkButton = true;
        def.resolve();
      });

      return def;
    },

    /**
    * Проверить заполненность обязательных реквизитов.
    * Если реквизиты не заполнены они подсвечиваются на форме.
    * @method WebAccess.components.dialogs.ReportParamsDialog#validateForm
    * @return {WebAccess.components.dialogs.ReportParamsDialog}
    */
    validateForm: function () {

      if (this._fillHiddenParamsCallback) {
        var hiddenParams = window[this._fillHiddenParamsCallback]();
        for (var reqKey in hiddenParams) {
          var currentReq = this.form.requisites[reqKey];
          if (currentReq) {
            currentReq.setValue(hiddenParams[reqKey], hiddenParams[reqKey]);
          }
        }
      }

      var requisites = this.form.requisites;
      window.req = requisites;
      var isValid = true;

      for (var name in requisites) {
        var requisite = requisites[name];
        if (requisite.isRequired && requisite.isRequired() && !requisite.getValue()) {
          requisite.highlight();
          isValid = false;
        }
      }

      if (!isValid) {
        this.inlineHint.showError(L('NOT_ALL_REQUIRED_FIELDS_FILLED'));
        WA.raise(L('NOT_ALL_REQUIRED_FIELDS_FILLED'));
      }

      return this;
    }
  });

  global.ReportParamsDialog = ReportParamsDialog;
})(window.WebAccess.components.dialogs);